export default __webpack_public_path__ + "static/media/icon.7abd3194.svg";